import { useRef, useState } from 'react';

/**
 * This is use to abstract the form modal logic
 * @returns {object} form
 */
export default function useForm() {
  const [formVisibility, setFormVisibility] = useState(false);
  const [editableRecord, setEditableRecord] = useState({});
  const form = useRef();

  const onFormOk = (callback) => {
    if (form.current) {
      form.current.validateFields().then((values) => {
        callback(values);
        setFormVisibility(false);
      }).catch((error) => {
        console.error(error.errorFields);
      });
    }
  };

  const handleShowModal = () => {
    if (form.current) {
      form.current.resetFields();
    }
    setFormVisibility(true);
  };

  const handleCancel = () => {
    setFormVisibility(false);
    setEditableRecord({});
  };

  const handleEditRecord = (record) => {
    setFormVisibility(true);
    setEditableRecord(record);
    setTimeout(() => {
      form.current.setFieldsValue(record);
    }, 300);
  };

  return {
    form,
    onFormOk,
    formVisibility,
    handleShowModal,
    handleCancel,
    editableRecord,
    handleEditRecord,
  };
}
